<template>
  <div>
    <p
      v-if="document.data && document.data.duplicatedDataValidation === false"
      class="text-danger font-larger font-weight-bold"
    >
      <span>
        Uwaga: Wniosek z takimi danymi został już złożony. W przypadku konieczności edycji proszę o kontakt&nbsp;
      </span>

      <span v-if="submitToSchool">ze&nbsp;szkołą.</span>

      <span v-else>z&nbsp;Wydziałem Oświaty i&nbsp;Wychowania UM.</span>
    </p>

    <p v-if="document.data && document.data.veryImportantErrors" class="text-danger font-larger font-weight-bold">
      {{ document.data.veryImportantErrors }}
    </p>

    <p v-if="document.data && document.data.warnings && document.data.warnings.length" class="text-danger">
      W edycji wniosku występują błędnie uzupełnione pola, lub pola obowiązkowe nie zostały uzupełnione. Upewnij się, że
      chcesz zakończyć edycję i ostatecznie zapisać wniosek w obecnej postaci.
    </p>

    {{ schema.text.$model }}
  </div>
</template>

<script>
import { mapState } from 'vuex';

// @vuese
// Modal ręcznego podpisywania dokumentu
// @group ActionData
export default {
  props: {
    // schema akcji
    schema: { type: Object, required: true }
  },
  computed: {
    ...mapState({ document: state => state.document.data }),
    submitToSchool() {
      return this.document.data?.school?.financingType === 1;
    }
  }
};
</script>
